$ = require 'jquery'
View = require 'view'
templates = require 'views/internal/templates'
trackUe = require 'debug/trackUe'

module.exports = class SoftBlock extends View
  initialize: (boardId) ->
    @boardId = boardId

  events:
    'click .js-soft-block-signup': ->
      trackUe(
          "board soft block", "navigates", "to sign up page", "", "", "by clicking sign up button",
          { boardid: @boardId }
        )

    'click .js-soft-block-learn-more': ->
      trackUe(
          "board soft block", "navigates", "to home page", "", "", "by clicking learn more button",
          { boardid: @boardId }
        )

    'click .js-soft-block-login': ->
      trackUe(
          "board soft block", "navigates", "to login page", "", "", "by clicking login button",
          { boardid: @boardId }
        )

  render: ->
    @$el.html(templates.fill('soft_block'))
    @




// WEBPACK FOOTER //
// ./app/scripts/views/board/soft-block-view.coffee